import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';

import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';

import { PaymentFederalTaxes } from './../models/payment-federal-taxes';

import { PaymentFederalTaxesEventType } from './../payment-federal-taxes.event.type';

import { PaymentFederalTaxesService } from './../payment-federal-taxes.service';
import { Limit } from '../../limits/models/limits';

@Component({
	selector: 'app-payment-select-tax',
	templateUrl: './payment-select-tax.component.html',
	styleUrls: ['./payment-select-tax.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PaymentSelectTaxComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() paymentData: PaymentFederalTaxes;

	public form: FormGroup;
	private view = '[data-component="payment-select-tax"]';
	private today: number = Date.now();
	private viewHeight = 0;

	dataLimits: Array<Limit>;

	active = false;

	constructor(private formBuilder: FormBuilder, private paymentService: PaymentFederalTaxesService) {
		this.form = formBuilder.group({
			'paymentTypeTax': ['DARF', Validators.required],
		});
	}

	ngOnInit() {
		this.preload(true);

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		AppEventDispatcher.listen( PaymentFederalTaxesEventType.STEPS.PAYMENT_SELECT_STEP, () => {
			this.loadLimits();
		});
	}

	setSendListener() {
		AppEventDispatcher.listen( PaymentFederalTaxesEventType.PAYMENT_FEDERAL_TAXES_SEND, () => {
			this.send();
		});
	}

	ngOnDestroy() {
		this.removeListeners();
	}

	removeListeners() {
		AppEventDispatcher.removeListener( PaymentFederalTaxesEventType.PAYMENT_FEDERAL_TAXES_SEND );
		AppEventDispatcher.removeListener( PaymentFederalTaxesEventType.STEPS.PAYMENT_SELECT_STEP );
	}

	show() {
		const interval = setInterval(() => {

			if ($(this.view).length > 0) {
				const containerHeight = this.getStepHeight();

				this.viewHeight = containerHeight;

				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
				TweenMax.to('.buttons', .8, {delay: .8, bottom: 0, ease: Quint.easeOut});

				clearInterval(interval);
			}

		}, 10);
	}

	setTaxType() {
		this.paymentData.typeTax = this.form.controls.paymentTypeTax.value;
	}

	hide() {
		this.removeListeners();

		this.setTaxType();


		if (this.paymentData.typeTax === 'GPS') {

			AppEventDispatcher.dispatch( PaymentFederalTaxesEventType.STEPS_GPS.PAYMENT_GPS, { show: true });

		} else if (this.paymentData.typeTax === 'DARF') {

			AppEventDispatcher.dispatch( PaymentFederalTaxesEventType.STEPS_DARF.PAYMENT_DARF, { show: true });

		} else {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Selecione uma taxa!' });
		}

		TweenMax.to(this.view, .8, {delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	loadLimits() {

		this.paymentService.getDataLimits().subscribe( data => {
			data = data.filter((e) => {
				return e;
			});
			this.dataLimits = data;
			this.active = true;
			this.show();
			this.setSendListener();
			this.preload(false);


		}, error => {
			this.preload(false);

			if (error.error !== undefined) {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			}
		});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="transfers-other-banks"] .content', show: active, delay: delay});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	send() {
		if (this.form.valid) {
			this.hide();
		}
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/payment-select-tax/payment-select-tax.component.ts